import type { AxiosResponse } from "axios";
import axiosClient from "./axios_client";


const http = {
    async post<R>(url:string,payload?:any): Promise<AxiosResponse<R>> {
        return await axiosClient.post<R>(url,payload);
    },      
    async get<R>(url:string): Promise<AxiosResponse<R>> {
        return await axiosClient.get<R>(url);
    },
    async put<R>(url:string,payload:any): Promise<AxiosResponse<R>> {
        return await axiosClient.put<R>(url,payload);
    },

    async patch<R>(url:string,payload:any): Promise<AxiosResponse<R>> {
        return await axiosClient.patch<R>(url,payload);
    },
    async delete<R>(url:string): Promise<AxiosResponse<R>> {
        return await axiosClient.delete<R>(url);
    }
};

export default http;